import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const isAdminLoggedIn = localStorage.getItem('adminTokenLoo');

  return isAdminLoggedIn ? children : <Navigate to="/admin" />;
};

export default PrivateRoute;
